import styled from 'styled-components'

import { Button } from '@/components/ui/button'
import { Divider } from '@/components/ui/divider'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'
import { theme } from '@/theme/theme'

export const AddCarButton = styled(Button)(() => ({
  marginRight: 'auto',
}))

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
  width: '47rem',
}))

export const DynamicSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  minHeight: '38rem',
}))

export const Row = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: '1fr 1fr',
}))

export const LicensePlateFieldContainer = styled.div(({ theme }) => ({
  '& > button': {
    alignSelf: 'start',
    // Note: Keeps the action button aligned with the input - adds label margin on top
    marginTop: theme.space['28'],
  },
  display: 'grid',
  gap: theme.space['8'],
  gridTemplateColumns: '1fr auto',
}))

export const AvailabilityLabelRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['4'],
}))

export const AvailabilityTooltip = styled(Tooltip)(() => ({
  width: 'fit-content',
}))

export const ResidentFieldContainer = styled.div(({ theme }) => ({
  alignItems: 'flex-end',
  display: 'flex',
  gap: theme.space['12'],
  width: '100%',
}))

export const ResidentDateSelectContainer = styled.div<{ $hasDate: boolean }>(
  ({ $hasDate, theme }) => ({
    alignItems: 'end',
    columnGap: theme.space['12'],
    display: 'grid',
    gridTemplateColumns: '34.7rem 10.7rem',
    width: '100%',
    ...(!$hasDate && { marginBottom: theme.space['24'] }),
  }),
)

export const ResidentSelectContainer = styled.div<{ $hasDate: boolean }>(({ $hasDate }) => ({
  display: 'flex',
  flexDirection: 'column',
  ...($hasDate && { marginBottom: '-2.4rem' }),
}))

export const UnassignButton = styled(Button)<{ $hasError: boolean }>(({ $hasError, theme }) => ({
  ...($hasError && { marginBottom: theme.space['18'] }),
}))

export const MoveInOutDate = styled(Typography)(() => ({
  lineHeight: '2rem',
  marginTop: theme.space['4'],
}))

export const VehiclesSectionDivider = styled(Divider)(({ theme }) => ({
  marginBottom: theme.space['8'],
}))

export const VehiclesSectionContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
}))

export const NoResidentsPlaceholder = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: theme.space['16'],
  justifyContent: 'center',
}))

export const VehicleFormWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const VehicleFormInputsWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['32'],
}))

export const AssociateVehiclePopupContent = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  width: '47rem',
}))

export const AssociateVehicleDetails = styled.span(({ theme }) => ({
  color: theme.colors.black700,
  fontFamily: 'Montserrat',
  fontSize: '1.8rem',
  fontWeight: 700,
  lineHeight: '2.4rem',
}))
